import { useEffect, useState } from 'react'
import { runWhenTimeReached } from 'shared/utils'

const TICK_MS = 1000

// Seconds left until endsAt, counted from startsAt. Null before startsAt, and
// without the times.
export const useCountdown = (endsAt?: number, startsAt?: number) => {
  const [secondsLeft, setSecondsLeft] = useState<number | null>(null)

  useEffect(() => {
    setSecondsLeft(null)
    if (endsAt === undefined || startsAt === undefined) return

    let intervalId: ReturnType<typeof setInterval> | undefined

    // Counted from the clock, as timers are paused while the system sleeps
    const updateSecondsLeft = () =>
      setSecondsLeft(Math.max(Math.ceil((endsAt - Date.now()) / 1000), 0))

    const startCountdown = () => {
      updateSecondsLeft()
      if (!intervalId) intervalId = setInterval(updateSecondsLeft, TICK_MS)
    }

    const stopCountdownStart = runWhenTimeReached(startsAt, startCountdown)

    return () => {
      stopCountdownStart()
      if (intervalId) clearInterval(intervalId)
    }
  }, [endsAt, startsAt])

  return secondsLeft
}
